import React, { useEffect, useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ReclutamientoService from '../../services/reclutamientoService';

const PrivateFormValidator = () => {
    const { token } = useParams();
    const { t } = useTranslation();
    const [isValid, setIsValid] = useState(null);
    const [setError] = useState(null);

    useEffect(() => {
        const validateToken = async () => {
            try {
                console.log('Iniciando validación de token:', token);
                const response = await ReclutamientoService.validateToken(token);
                console.log('Respuesta de validación:', response);
                setIsValid(response.valid);
            } catch (err) {
                console.error('Error al validar token:', err);
                setError(t('form.private.error.validation'));
                setIsValid(false);
            }
        };

        if (token) {
            validateToken();
        } else {
            setIsValid(false);
        }
    }, [token, t]);

    if (isValid === null) {
        return (
            <div className="loading-container">
                <div className="loading-spinner"></div>
                <p>{t('form.private.validating')}</p>
            </div>
        );
    }

    if (!isValid) {
        return <Navigate to="/invalid-token" replace />;
    }

    return <Navigate to={`/private-form-content/${token}`} replace />;
};

export default PrivateFormValidator; 